module.exports = __webpack_public_path__ + "img/download_android.e62e3a30.png";